import { useMemo } from 'react';
import { trackEvent } from '@kcd/event-tracker';

import { SectionDivider } from '~/components/SectionDividor';
import { useShoppingCartItemsV3 } from '~/domains/cart/queries';
import { useEffectOnce } from '~/hooks/lifecycle';
import RecentlyViewedProducts from '~/pages/app/components/RecentlyViewedProducts';

import { CartCheckAllBox } from '../CartCheckAllBox';
import CartOrderButton from '../CartOrderButton';
import { CartVendorGroup } from '../CartVendorGroup';
import EmptyCart from '../EmptyCart';
import { MembershipDiscountBanner } from '../MembershipDiscountBanner';
import UnbuyableShoppingCartGroup from '../UnbuyableShoppingCartGroup';

const CartContainer = () => {
  const { data, flatList, totalCount } =
    useShoppingCartItemsV3('SHOPPING_CART');

  useEffectOnce(() => {
    trackEvent('viewed 마켓/장바구니 page', {
      productName: [...flatList.map(({ productName }) => productName)],
      offerId: [...flatList.map(({ offerId }) => offerId)],
    });
  });

  const cartItemChecked = useMemo(() => {
    const checkedCount =
      flatList?.filter(({ isSelected }) => isSelected).length || 0;
    const allChecked =
      !!flatList.length && flatList.every(({ isSelected }) => isSelected);
    return {
      checkedCount,
      allChecked,
    };
  }, [flatList]);

  if (totalCount === 0) {
    return <EmptyCart />;
  }

  return (
    <>
      <CartCheckAllBox
        totalCount={totalCount}
        flatList={flatList}
        {...cartItemChecked}
      />
      <SectionDivider />
      <MembershipDiscountBanner />
      <CartVendorGroup data={data?.shoppingCartVendorGroups || []} />
      <RecentlyViewedProducts titleClassName="typo-title100-semibold" />
      <UnbuyableShoppingCartGroup
        data={data?.unbuyableShoppingCartItems || []}
      />
      <CartOrderButton />
    </>
  );
};

export default CartContainer;
